module.exports = __webpack_public_path__ + "static/Raven-BW-Square-sm.71269a78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/Raven-BW-Square-sm.jpg
// module id = 455
// module chunks = 144251824217401